<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
        <g stroke="#DA4E4E">
            <g transform="translate(-511 -573) translate(511 573)">
                <circle cx="12" cy="12" r="11"/>
                <g stroke-linecap="round">
                    <g>
                        <path d="M.111 0L7.778 7.667M.111 7.333L7.428.017" transform="translate(8 8)"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
</template>
<script>
export default {
    name: "cancel-icon"
}
</script>